<template>
    <component
      :is="DynamicComponent"
      :args="args"
      :finished.sync="finished"
      ref="form_action"
    ></component>
</template>

<script>
  import { sync } from "vuex-pathify";
  import phraseProc from "@/../../library/helper/phrase.js";
  export default {
  
    props: ["args"],
    data: () => ({
      finished: false,
    }),
    computed: {
      loader: sync("login/loader"),
      userlang: sync("misc/language"),
      phrases: sync("misc/phraseMap"),
      DynamicComponent() {
        return this.args.component;
      },
    },
    methods: {
      dialog() {
        console.log(`Attempting to close dialog ------`);
        this.$emit("update:show", false);
      },
    },
    watch: {
      finished() {
        this.dialog();
      },
    },
    mounted() {
    },
  };
</script>
